module.exports = __webpack_public_path__ + "static/img/Bachelor_010779.09f7631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010779.jpg
// module id = 244
// module chunks = 0